import React, {useState, useRef, useEffect} from 'react';
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import { useSelector } from 'react-redux';
import MainFilter from '../../components/Tools/MainFilter';
import DashboardFilter from '../Dashboard/components/DashboardFilter';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import { 
    getBeneficiaryPPAList, 
    getExportBeneficiaryPPAList, 
    getSubActivity
} from '../../helper/Api';
import Spinner from '../../components/Tools/spinner';
import { toast } from "react-toastify";
import { isValidURL } from '../../helper/Utils';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const columns = [
  { id: 'id', label: '#', minWidth: 50 },
  { id: 'sno', label: 'S.No', minWidth: 50 },
  { id: 'ppa_no', label: 'PPA No', minWidth: 100 },
  { id: 'order_no', label: 'Voucher / Order No', minWidth: 100 },
  {
    id: 'l3_approval_datetime',
    label: 'PPA Approval Datetime',
    minWidth: 150,
  },
  {
    id: 'invoice_count',
    label: 'Total Credit Account',
    minWidth: 100,
  },
  {
    id: 'beneficiary_name',
    label: 'Beneficiary Name',
    minWidth: 170,
  },
  {
    id: 'account_no',
    label: 'Account No',
    minWidth: 150,
  },
  {
    id: 'ifsc_code',
    label: 'IFSC Code',
    minWidth: 100,
  },
  {
    id: 'sanctioned_amount',
    label: 'Sanctioned Amount',
    minWidth: 100,
  },
  {
    id: 'deduction_amount',
    label: 'Deduction Amount',
    minWidth: 100,
  },
  {
    id: 'payment_amount',
    label: 'Payment Amount',
    minWidth: 100,
  },
];

const SubactivityPPA = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const fyId = localStorage.getItem('globalDateId');
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.5); 
    const [rows, setRows] = useState([]);
    const [dataLength, setDataLength] = useState(0);
    const [showSubactivity, setShowSubactivity] = useState(true);
    const [subActivity, setSubActivities] = useState([]);
    const [subactivityExpense, setSubactivityExpense] = useState([]);
    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: ""
    });

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(500);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

    const handleChangePage = async (event, newPage) => {
        setPage(newPage);
        console.log('New Page:', newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(+event.target.value);
    };

    const handleCheckboxChange = (event, id) => {
        const { checked } = event.target;
        if (checked) {
            setSelectedCheckboxes((prev) => [...prev, id]);
        } else {
            setSelectedCheckboxes((prev) => prev.filter((item) => item !== id));
        }
    };

    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const handleFilterRemove = async (name) => {
        let newPayload;
        if(name === 'fromDate') {
            newPayload = {
                ...filterPayload,
                fromDate: "",
                toDate: ""
            };
        } else {
            newPayload = {
                ...filterPayload,
                [name]: "",
            };
        }
        setFilterPayload(newPayload);
        await fetchRecordsWithPayload(newPayload);
    }

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }
    const handleFilterClick = async () => {
        setOpen(false);
        await fetchRecords();
    };

    // const downloadFile = (url) => {
    //     if (!url || !isValidURL(url)) {
    //         toast.error('Invalid download URL', { position: toast.POSITION.TOP_CENTER });
    //         return;
    //     }
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "PPA-Subactivity-Expense.xlsx"); // Suggested filename
    //     // safer attributes for programmatically created links
    //     link.setAttribute("rel", "noopener noreferrer");
    //     link.setAttribute("target", "_blank");
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

    const ALLOWED_HOSTS = [
        // "my-bucket.s3.amazonaws.com",
        "tangy-media-sms.s3.ap-south-1.amazonaws.com"
    ];

    const downloadFile = (url) => {
        try {
            if (!url) {
            throw new Error("Empty URL");
            }

            const parsedUrl = new URL(url);

            // allow only https
            if (parsedUrl.protocol !== "https:") {
            throw new Error("Invalid protocol");
            }

            // allow only trusted domains
            if (!ALLOWED_HOSTS.includes(parsedUrl.hostname)) {
            throw new Error("Untrusted download source");
            }

            const link = document.createElement("a");
            link.href = parsedUrl.href;
            link.download = "PPA-Subactivity-Expense.xlsx";
            link.rel = "noopener noreferrer";
            link.target = "_blank";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (err) {
            console.error("Blocked unsafe download URL:", err);
            toast.error("Invalid or unsafe download URL", {
            position: toast.POSITION.TOP_CENTER
            });
        }
        };

    const fetchExcelRecords = async (payload) => {
        try {
            setLoading(true);
            const resp = await getExportBeneficiaryPPAList({
                from_date: payload.fromDate, 
                to_date: payload.toDate, 
                search_str: payload.searchStr, 
                department_id: authData.user.department_id,
                subactivity_reporting: 'yes',
                ppa_invoice_batch_ids: selectedCheckboxes.join(',') // Array ko comma-separated string mein convert
            });
            if (resp.data.status) {
                setLoading(false);
                downloadFile(resp.data.url);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const fetchRecordsWithPayload = async (payload) => {
        try {
            setLoading(true);
            const resp = await getBeneficiaryPPAList({
                limit: rowsPerPage, offset: page + 1, 
                from_date: payload.fromDate, 
                to_date: payload.toDate, 
                search_str: payload.searchStr, 
                department_id: authData.user.department_id
            });
            if (resp.data.status) {
                setRows(resp.data.result.data);
                setDataLength(resp.data.result.total_count);
                setSubactivityExpense(resp.data.subactivity);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setRows([]);
        }
    }

    const fetchExcel = async () => {
        await fetchExcelRecords(filterPayload);
    }

    const fetchRecords = async () => {
        await fetchRecordsWithPayload(filterPayload);
    }
    const fetchSubActivities = async () => {
        try {
          const response = await getSubActivity();
          if (response.status === 200) {
            let subactivityOrder = [10,11,12,13,14,15,16,17,18,7,8,9,4,5,6];
            let modifiedArray = [];
            subactivityOrder.forEach(id => {
              const found = response.data.result.find(item => Number(item.id) === id);
              if (found) {
                modifiedArray.push(found);
              }
            });
            setSubActivities(modifiedArray);
          } else {
            toast.error("Failed to fetch sub-activities", {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          toast.error("Something went wrong while fetching sub-activities!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
    };

    useEffect(() => {
        fetchSubActivities();
    }, []);

    useEffect(() => {
        console.log('Setting max height for table container', window.innerHeight );
        const handleResize = () => {
        setMaxHeight(window.innerHeight * 0.7); // 60% of screen height
        };

        handleResize(); // Call once on mount
        window.addEventListener('resize', handleResize);
        fetchRecords();
        return () => window.removeEventListener('resize', handleResize);
        
    }, [page, rowsPerPage]);

    



    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>PPA Sub-Activity Utilization</h4>
                    <CustomBreadcrumbs linksArray={[]} title="PPA Sub-Activity Utilization"/>
                </div>
                <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                        {
                            showSubactivity ? (
                                <button type="button" className="navigation_button" onClick={() => setShowSubactivity(false)}>
                                    <span className="fs-14px">Hide Subactivity</span>
                                </button>
                            ) : (
                                <button type="button" className="submit_button" onClick={() => setShowSubactivity(true)}>
                                    <span className="fs-14px">Show Subactivity</span>
                                </button>
                            )
                        }
                        <button 
                            type="button" 
                            className="submit_button" 
                            onClick={async () => await fetchExcel()}
                            disabled={selectedCheckboxes.length === 0}
                        >
                            <span className="fs-14px">Export Excel ({selectedCheckboxes.length})</span>
                        </button>
                    </div>
                </div>

                <div className='col-md-12'>
                    <DashboardFilter openFilterModal={setOpen} filterPayload={filterPayload} handleFilterRemove={handleFilterRemove}></DashboardFilter>

                    <div className='row'>
                        <div className={`col-md-${showSubactivity ? '8' : '12'}`}>
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: maxHeight }}>
                                    <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                            >
                                            {column.label}
                                            </TableCell>
                                        ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={columns.length} align="center">
                                                    <span style={{ fontSize: '16px', color: '#666' }}>No data found</span>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            rows.map((row, index) => {
                                                return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                                    <TableCell>
                                                        <input 
                                                            type="checkbox" 
                                                            value={row.ppa_invoice_batch_id}
                                                            checked={selectedCheckboxes.includes(row.ppa_invoice_batch_id)}
                                                            onChange={(e) => handleCheckboxChange(e, row.ppa_invoice_batch_id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{index+1 + (page * rowsPerPage)}</TableCell>
                                                    <TableCell>{row.ppa_no}</TableCell>
                                                    <TableCell>{row.invoice_id || row.beneficiary_reimbursement_id || row.salary_id}</TableCell>
                                                    <TableCell>{row.l3_approval_datetime}</TableCell>
                                                    <TableCell>{row.invoice_count}</TableCell>
                                                    <TableCell>{row.invoice_beneficiary_name || row.reimbursement_beneficiary_name}</TableCell>
                                                    <TableCell>{row.invoice_beneficiary_account_no || row.reimbursement_beneficiary_account_no}</TableCell>
                                                    <TableCell>{row.invoice_beneficiary_ifsc_code || row.reimbursement_beneficiary_ifsc_code}</TableCell>
                                                    <TableCell>{row.invoice_sanctioned_amount || row.reimbursement_gross_amount}</TableCell>
                                                    <TableCell>{row.invoice_total_deduction || row.reimbursement_deduction_amount}</TableCell>
                                                    <TableCell>{row.invoice_total_payable || row.reimbursement_net_amount}</TableCell>
                                                </TableRow>
                                                );
                                            })
                                        )}
                                    </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[500, 1000, 2000]}
                                    component="div"
                                    count={dataLength}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </div>
                        <div className={`col-md-4 ${showSubactivity ? '' : 'd-none'}`}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 250 }} aria-label="customized table">
                                    <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Sub Activity</StyledTableCell>
                                        <StyledTableCell align="right">Expense</StyledTableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {subActivity.map((activity, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell component="th" scope="row">
                                                    {activity.subactivity}
                                                </StyledTableCell>
                                                <StyledTableCell align="right">{subactivityExpense?.find(e => e.subactivity_id == activity.id)?.total_amount || 0}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        
        <MainFilter 
            open={open} 
            handleClose={handleClose} 
            handleInput={handleInput} 
            handleOpen={handleOpen}
            filterPayload={filterPayload}
            handleFilterClick={handleFilterClick}
            type="ppa_subactivity_utilization"
        />
        </div>
    )
}

export default SubactivityPPA;